import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch } from "antd";

import moment from "moment";

import { holidaysService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UIInfoBanner,
	UISwitchField,
} from "./../../components";

const renderNames = (items, emptyLabel) => items?.length > 0
	? items.map((item) => <div key={item.id}>{item.nome}</div>)
	: emptyLabel;

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			item: {},
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			item: {},
		});

		holidaysService.show({ uuid })
			.then((response) => {
				this.setState({
					isLoading: false,
					item: response.data.data,
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	onClose = () => {
		this.setState({
			item: {},
		});

		// Callback
		this.props.onClose();
	};

	render() {
		const { visible } = this.props;
		const { isLoading, item } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-calendar-alt" />}
				title="Visualizar feriado"
				subtitle="Consulte as informações do feriado e a quem ele se aplica.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Nome, data e regras do feriado.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Descrição">
									{item.descricao ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Data do feriado">
									{item.data_feriado ? moment(item.data_feriado, "YYYY-MM-DD").format("DD/MM/YYYY") : "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Recorrência">
									<UISwitchField
										bordered
										title="Recorrente"
										description={item.recorrente ? "Sim, este feriado se repete todos os anos." : "Não, este feriado vale só na data cadastrada."}>
										<Switch disabled checked={!!item.recorrente} />
									</UISwitchField>
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Status">
									<UISwitchField
										bordered
										title="Ativo"
										description={item.ativo ? "Feriado ativo e considerado no cálculo do ponto." : "Feriado inativo e não considerado no cálculo do ponto."}>
										<Switch disabled checked={!!item.ativo} />
									</UISwitchField>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Criação">
									{item.created_at ? moment(item.created_at).calendar() : "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Última atualização">
									{item.updated_at ? moment(item.updated_at).calendar() : "-"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<UIFormSection
						icon={<i className="fal fa-users" />}
						title="Abrangência"
						description="Empresas, departamentos e funcionários aos quais o feriado se aplica.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Empresa(s)">
									{renderNames(item.empresas, "Todas")}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Departamento(s)">
									{renderNames(item.departamentos, "Todos")}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Funcionário(s)">
									{renderNames(item.funcionarios, "Todos")}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<UIInfoBanner
						icon={<i className="fal fa-info-circle" />}
						title="Sobre este feriado"
						description={item.ativo
							? "Este feriado entra no cálculo do ponto dos funcionários a que se aplica."
							: "Este feriado está inativo e não entra no cálculo do ponto."}
					/>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
